import _ from 'lodash';
import { Component } from 'react';
import ReactDOM from 'react-dom';

const makeTrackable = (WrappedComponent, { name = 'item', domNodeName = false } = {}) =>
  class extends Component {
    componentDidMount() {
      let domNode = ReactDOM.findDOMNode(this);
      if (domNodeName) {
        domNode = domNode.getElementsByTagName(domNodeName)[0];
      }
      _.keys(this.props.track).forEach(k => {
        const v = this.props.track[k];

        const propKey = `data-${k}`;

        if (typeof v === 'function') {
          domNode.setAttribute(propKey, v.call(this, this.props[name]));
        } else {
          domNode.setAttribute(propKey, v);
        }
      });
    }

    render() {
      if (!this.props.track) {
        console.warn(this, 'trck obj missing');
      }
      const props = _.omit(this.props, 'track');

      return <WrappedComponent {...props} />;
    }
  };

export default makeTrackable;
